import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import api, { formatPrice } from "@/lib/api";

export default function Chats() {
  const [convs, setConvs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/conversations").then((r) => setConvs(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="mx-auto max-w-3xl px-4 pb-24 pt-6 md:px-8 md:pb-12">
      <h1 className="mb-6 font-display text-3xl text-[#F5F5F5] sm:text-4xl">CHATS</h1>

      {loading ? (
        <div className="space-y-3">
          {["c1","c2","c3","c4"].map((k) => (
            <div key={k} className="h-20 animate-pulse rounded-xl border border-[#333] bg-[#1c1c1c]" />
          ))}
        </div>
      ) : convs.length === 0 ? (
        <div className="flex flex-col items-center justify-center rounded-2xl border border-[#333] bg-[#1c1c1c] py-20 text-center" data-testid="chats-empty">
          <MessageCircle className="mb-3 h-10 w-10 text-[#555]" />
          <p className="font-display text-xl text-[#F5F5F5]">Nog geen chats</p>
          <p className="mt-2 max-w-xs text-sm text-[#A0A0A0]">Start een gesprek met een verkoper via een advertentie.</p>
          <Link to="/zoeken" className="mt-4 rounded-full bg-[#FF6A00] px-5 py-2.5 font-bold text-[#111]">Bekijk aanbod</Link>
        </div>
      ) : (
        <div className="space-y-2" data-testid="chats-list">
          {convs.map((c) => (
            <Link key={c.id} to={`/chats/${c.id}`} data-testid={`chat-item-${c.id}`} className="flex items-center gap-3 rounded-xl border border-[#333] bg-[#1c1c1c] p-3 transition-colors hover:border-[#FF6A00]">
              <img src={c.listing?.image} alt="" className="h-14 w-14 shrink-0 rounded-lg bg-[#2A2A2A] object-cover" />
              <div className="min-w-0 flex-1">
                <div className="flex items-center justify-between gap-2">
                  <p className="truncate font-semibold text-[#F5F5F5]">{c.other_user?.name}</p>
                  <span className="shrink-0 text-xs text-[#A0A0A0]">{c.listing ? formatPrice(c.listing.price) : ""}</span>
                </div>
                <p className="truncate text-sm text-[#A0A0A0]">{c.listing?.title}</p>
                {c.last_message && <p className="truncate text-sm text-[#777]">{c.last_message.text}</p>}
              </div>
              {c.unread > 0 && <span data-testid={`chat-unread-${c.id}`} className="flex h-6 min-w-6 shrink-0 items-center justify-center rounded-full bg-[#FF6A00] px-1.5 text-xs font-bold text-[#111]">{c.unread}</span>}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
